import {
  ImportShipmentsModal,
  ImportShipmentsModalRef,
} from '@modules/Invoices/InvoicesOrders/List/components/modals/ImportShipmentsModal';
import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DATA_LOAD_UPLOADS, type DataLoadUploadDefinition } from '../../models';
import { UploadsList } from '../display/UploadsList';
import { CourierWeightUploadDialog } from '../interaction/CourierWeightUploadDialog';

export const Main = () => {
  const { t } = useTranslation('dataLoadModule');
  const [courierWeightDialogOpen, setCourierWeightDialogOpen] = useState(false);
  const importShipmentsModalRef = useRef<ImportShipmentsModalRef>(null);

  const handleUploadClick = useCallback((upload: DataLoadUploadDefinition) => {
    if (upload.id === 'accounting_shipments') {
      importShipmentsModalRef.current?.open();
      return;
    }

    if (upload.id === 'courier_weight_files') {
      setCourierWeightDialogOpen(true);
    }
  }, []);

  return (
    <div
      className="mx-auto flex min-h-0 w-full max-w-3xl flex-1 flex-col px-6 pt-6 pb-10"
      data-testid="accounting-data-load-view"
    >
      <div className="shrink-0">
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">{t('pageTitle')}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t('pageDescription')}</p>
      </div>

      <div className="mt-6">
        <UploadsList uploads={DATA_LOAD_UPLOADS} onUpload={handleUploadClick} />
      </div>

      <CourierWeightUploadDialog open={courierWeightDialogOpen} onOpenChange={setCourierWeightDialogOpen} />
      <ImportShipmentsModal ref={importShipmentsModalRef} />
    </div>
  );
};
